<div class="critter-content">
  <div>
    <h2 class="confirm title header-text heavy-header-text" mat-dialog-title>
      Yay, you got a ...
    </h2>
    <mat-dialog-content>
      <div class="col justify-center align-items-centered">
        <img class="critter" [src]="critterImage" alt="Image of a critter" />
        <h3>{{ critter.name }}</h3>
      </div>
    </mat-dialog-content>
  </div>
  <mat-dialog-actions class="centered">
    <app-confirm-cancel [buttonConfig]="buttonConfig" (emitSubmit)="submit()">
    </app-confirm-cancel>
  </mat-dialog-actions>
</div>
